import { ApiService } from '@/utils/api'

export async function parseTabularImportFile(
  connectionId: string,
  objectName: string,
  file: File,
): Promise<{ columns: string[]; rows: Record<string, unknown>[]; total_rows: number }> {
  const formData = new FormData()
  formData.append('file', file)
  const envelope = await ApiService.post<{ data: { columns: string[]; rows: Record<string, unknown>[]; total_rows: number } }>(
    `/v1/app/${encodeURIComponent(connectionId)}/${encodeURIComponent(objectName)}/tabular-import/parse`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  )
  return envelope.data
}

export async function resolveRefsBatch(
  connectionId: string,
  body: { target: string; field: string; values: unknown[] },
): Promise<Record<string, { id: string | null; status: 'ok' | 'missing' | 'ambiguous' }>> {
  const envelope = await ApiService.post<{ data: { results: Record<string, { id: string | null; status: 'ok' | 'missing' | 'ambiguous' }> } }>(
    `/v1/app/${encodeURIComponent(connectionId)}/_resolve-refs`,
    body,
  )
  return envelope.data.results
}

export async function resolveEnumsBatch(
  connectionId: string,
  body: { enum_target: string; object_name: string; values: unknown[] },
): Promise<Record<string, { name: string | null; status: 'ok' | 'missing' | 'ambiguous' }>> {
  const envelope = await ApiService.post<{
    data: { results: Record<string, { name: string | null; status: 'ok' | 'missing' | 'ambiguous' }> }
  }>(`/v1/app/${encodeURIComponent(connectionId)}/_resolve-enums`, body)
  return envelope.data.results
}